import React from 'react';
import {
  SpinnerWrapper,
  StyledSpinner,
  LoadingSkeletonWrapper,
  SkeletonTabsRow,
  SkeletonTabPill,
  SkeletonCard,
  SkeletonImage,
  SkeletonContent,
  SkeletonLine,
} from './SidewideSearch.styles';

interface SpinnerProps {
  size?: number | undefined;
}

const Spinner: React.FC<SpinnerProps> = ({ size }) => {
  if (!process.env.IS_LEGACY) {
    return (
      <LoadingSkeletonWrapper data-testid="spinner">
        <SkeletonTabsRow>
          <SkeletonTabPill />
          <SkeletonTabPill />
          <SkeletonTabPill />
        </SkeletonTabsRow>

        {Array.from({ length: 5 }).map((_, index) => (
          <SkeletonCard key={index}>
            <SkeletonImage />
            <SkeletonContent>
              <SkeletonLine width="88%" />
              <SkeletonLine width="58%" />
              <SkeletonLine width="62%" />
            </SkeletonContent>
          </SkeletonCard>
        ))}
      </LoadingSkeletonWrapper>
    );
  }

  return (
    <SpinnerWrapper>
      <StyledSpinner size={size} data-testid="spinner" />
    </SpinnerWrapper>
  );
};

export default Spinner;
